import { clsx } from 'clsx'

import {
  type AvatarSize,
  avatarStyles,
} from '@tribeplatform/react-ui-kit/Avatar'

import { initials } from './utils.js'

const getIndexFromHash = (name: string) => {
  if (!name) {
    return 0
  }

  const decorativeColorsLength = 7
  const index =
    name.split('').reduce((prev, curr) => prev + curr.charCodeAt(0), 0) %
    decorativeColorsLength

  return index
}

export interface InitialsAvatarPlaceholderProps {
  name: string
  size: AvatarSize
}

export const InitialsAvatarPlaceholder = ({
  name,
  size,
}: InitialsAvatarPlaceholderProps) => {
  const decorativeIndex = getIndexFromHash(name) + 1
  return (
    <div
      className={clsx(
        avatarStyles({
          size,
        }),
        'flex items-center justify-center',
        [
          decorativeIndex === 1 &&
            'bg-decorative-surface-1-subdued text-decorative-content-1',
          decorativeIndex === 2 &&
            'bg-decorative-surface-2-subdued text-decorative-content-2',
          decorativeIndex === 3 &&
            'bg-decorative-surface-3-subdued text-decorative-content-3',
          decorativeIndex === 4 &&
            'bg-decorative-surface-4-subdued text-decorative-content-4',
          decorativeIndex === 5 &&
            'bg-decorative-surface-5-subdued text-decorative-content-5',
          decorativeIndex === 6 &&
            'bg-decorative-surface-6-subdued text-decorative-content-6',
          decorativeIndex === 7 &&
            'bg-decorative-surface-7-subdued text-decorative-content-7',
        ],
      )}
    >
      <span
        translate="no"
        className={clsx('text-lg font-medium uppercase', [
          size === 'xxs' && 'text-xs',
          size === 'xs' && 'text-xs',
          size === 'sm' && 'text-sm',
          size === 'md' && 'text-md',
          size === 'lg' && 'text-lg',
          size === 'xl' && 'text-lg',
          size === '2xl' && 'text-xl',
          size === '3xl' && 'text-xl',
        ])}
      >
        {initials(name)}
      </span>
    </div>
  )
}
